<template>
        <v-container v-if="isBoolean" class="d-flex justify-center align-center pa-0 fill-height">
            <v-icon  :icon="icon" :color="color" size="large" />
        </v-container>
        <span v-else>{{ translation }}</span>
</template>

<script setup>
    import { computed } from 'vue';
    import { mdiCheck, mdiClose } from '@mdi/js';

    const props = defineProps(['params']);

    const isIsCustomColumn = computed(() => props.params.colDef.field.indexOf('isCustom') > -1);

    // THE "isCustom" COLUMN ALWAYS RENDERS AS A BOOLEAN, THE LOCALE COLUMN ALWAYS RENDERS AS TEXT
    const isBoolean = computed(() => isIsCustomColumn.value && !!props.params.node);

    const isTrue = computed(() => {
        if (isIsCustomColumn.value && typeof props.params.data != 'undefined' && typeof props.params.data.localesCustom != 'undefined') {
            const countryCode = props.params.colDef.field.replace('isCustom', '').toLowerCase();

            return typeof props.params.data.localesCustom[countryCode] != 'undefined' && props.params.data.localesCustom[countryCode];
        }
        // FILTER POPUP - NO ROW CONTEXT AVAILABLE
        return props.params.value === true || props.params.value === 'true';
    });

    const translation = computed(() => props.params.value ?? '');

    const icon = computed(() => isTrue.value ? mdiCheck : mdiClose);

    const color = computed(() => isTrue.value ? 'success' : 'error');
</script>

